import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const BRAND = {
  name: 'Royal Fresh - Garissa',
  tagline: 'Milk Distribution Management System'
};

const writeHeader = (doc, title) => {
  doc.setFontSize(14);
  doc.text(BRAND.name, 14, 16);
  doc.setFontSize(10);
  doc.text(BRAND.tagline, 14, 22);
  doc.setFontSize(12);
  doc.text(title, 14, 30);
};

export const downloadReceiptPdf = ({ title, metaLines = [], columns = [], rows = [], filename }) => {
  const doc = new jsPDF();
  writeHeader(doc, title);

  let currentY = 36;
  doc.setFontSize(9);
  metaLines.forEach((line) => {
    doc.text(line, 14, currentY);
    currentY += 5;
  });

  autoTable(doc, {
    head: [columns],
    body: rows,
    startY: currentY + 4,
    styles: { fontSize: 9 }
  });

  doc.save(filename);
};

export const printReceiptWindow = ({ title, metaLines = [], columns = [], rows = [] }) => {
  const receiptWindow = window.open('', '_blank', 'width=800,height=600');
  if (!receiptWindow) return;

  receiptWindow.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 24px; }
          h1 { font-size: 20px; margin-bottom: 4px; }
          .tagline { font-size: 12px; color: #555; margin-bottom: 12px; }
          .meta { margin-bottom: 16px; font-size: 12px; color: #555; }
          table { width: 100%; border-collapse: collapse; margin-top: 16px; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          th { background: #f3f4f6; }
        </style>
      </head>
      <body>
        <h1>${BRAND.name}</h1>
        <div class="tagline">${BRAND.tagline}</div>
        <div class="meta">
          <div><strong>${title}</strong></div>
          ${metaLines.map((line) => `<div>${line}</div>`).join('')}
        </div>
        <table>
          <thead>
            <tr>
              ${columns.map((col) => `<th>${col}</th>`).join('')}
            </tr>
          </thead>
          <tbody>
            ${rows
              .map(
                (row) =>
                  `<tr>${row.map((cell) => `<td>${cell}</td>`).join('')}</tr>`
              )
              .join('')}
          </tbody>
        </table>
      </body>
    </html>
  `);
  receiptWindow.document.close();
  receiptWindow.focus();
  receiptWindow.print();
};
